import React from 'react';
import { useParams } from 'react-router-dom';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import useCoach from 'components/Common/Coaches/Hooks/useCoach';
import CoachProfile from 'components/Common/Coaches/Views/Profile/Index';

export default function Index() {
  const { coachId } = useParams();
  const coach = useCoach(coachId);

  return (
    <div className="content">
      {coach === null ? (
        <LoadingPlaceholder text="Loading..." className="py-5" />
      ) : (
        <section>
          <CoachProfile coach={coach} />
        </section>
      )}
    </div>
  );
}
